const STORAGE_KEY = 'pardes:recent-searches';
const MAX_RECENT = 5;

const readRecent = () => {
	try {
		const raw = localStorage.getItem(STORAGE_KEY);
		const parsed = raw ? JSON.parse(raw) : [];
		return Array.isArray(parsed)
			? parsed.filter((q) => typeof q === 'string' && q.trim() !== '')
			: [];
	} catch {
		return [];
	}
};

const writeRecent = (list) => {
	try {
		localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
	} catch {}
};

const rememberQuery = (query) => {
	if (!query) return;
	const next = [query, ...readRecent().filter((q) => q !== query)].slice(0, MAX_RECENT);
	writeRecent(next);
};

const renderRecent = (root, currentQuery) => {
	const container = root.querySelector('[data-search-recent]');
	if (!container) return;

	const wrapper = root.querySelector('[data-search-past]');
	const searchUrl = container.dataset.searchUrl || '/';
	const items = readRecent().filter((q) => q !== currentQuery);

	container.textContent = '';

	if (items.length === 0) {
		if (wrapper) wrapper.hidden = true;
		return;
	}

	const frag = document.createDocumentFragment();
	items.forEach((query) => {
		const link = document.createElement('a');
		link.className = 'search-results__pill search-results__pill--recent';
		link.textContent = query;
		link.href = `${searchUrl}?s=${encodeURIComponent(query)}`;
		frag.appendChild(link);
	});

	container.appendChild(frag);
	if (wrapper) wrapper.hidden = false;
};

const wirePerPage = (root) => {
	const select = root.querySelector('[data-per-page]');
	if (!select) return;

	select.addEventListener('change', () => {
		const url = new URL(window.location.href);
		url.searchParams.set('per_page', select.value);
		url.searchParams.delete('paged');
		window.location.href = url.toString();
	});
};

const SearchResultsForm = {
	init() {
		const root = document.querySelector('[data-component="search-results"]');
		if (!root) return;

		const currentQuery = (root.dataset.query || '').trim();

		rememberQuery(currentQuery);
		renderRecent(root, currentQuery);
		wirePerPage(root);
	},
};

export default SearchResultsForm;
